import axios from 'axios';
import { LOGIN_API_URL, REGISTRATION_API_URL } from '../OpticApiConfig';
import {ROLE_DEFAULT} from '../Constants/ConstantsOptics'


export const handleLogin = async (username, password, setToken, showSnackbar) => {
  try {
    const response = await axios.post(LOGIN_API_URL, { 
      Username: username,
      Password: password
    });
    const token = response.data.token;
    console.log("ddd",response.data);
    const refreshToken = response.data.refreshToken;
    const { username: user } = response.data.users;
    const { name: name } = response.data.users;
    const { phone: phone } = response.data.users;
    const { email: email } = response.data.users;
    const { roleId: roleId } = response.data.users;
    const { territory: territory } = response.data.users;
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('token', token);
    localStorage.setItem('username', user);
    localStorage.setItem('name', name);
    localStorage.setItem('phone', phone);
    localStorage.setItem('email', email);
    localStorage.setItem('roleId', roleId);
    localStorage.setItem('territory', territory);
    setToken(token);
    console.log(response.data.users);
    window.location.href = '/';
  } catch (error) {
    if (error.response) {
      // Сервер ответил с кодом состояния, отличным от 2xx
      showSnackbar(error.response.data.message || 'Ошибка входа', 'snackbarWarning');
    } else if (error.request) {
      showSnackbar("Нет ответа от сервера.");
    } else {
      // Произошла ошибка при настройке запроса
      showSnackbar("Произошла ошибка.");
    }
  }
};

export const handleRegister = async (username, password, confirmPassword, email, showSnackbar, setUsername, setPassword, setConfirmPassword, setEmail) => {
    if (!username || !password || !confirmPassword || !email) {
      showSnackbar('Все поля должны быть заполнены!', 'snackbarWarning');
      return;
    }
    if (password.length < 8) {
      showSnackbar('Пароль должен быть не менее 8 символов!', 'snackbarWarning');
      return; 
    }
    if (password !== confirmPassword) {
      showSnackbar('Пароли не совпадают!', 'snackbarWarning');
      return;
    }

    //const strongPasswordPattern = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{8,})");
    const strongPasswordPattern = new RegExp(
      "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*\\(\\)_\\+\\-=\\[\\]\\{\\};:'\"\\\\|,.<>\\/\\?`~])(?=.{8,})"
    );
    if (!strongPasswordPattern.test(password)) {
      showSnackbar('Пароль должен содержать как минимум одну заглавную букву, одну строчную букву, одну цифру и один специальный символ!', 'snackbarWarning');
      return;
    }
  
    try {
      const response = await axios.post(REGISTRATION_API_URL, {
        Username: username,
        Email: email,
        Password: password,
        ConfirmPassword: confirmPassword,
        UserRoleId: ROLE_DEFAULT 
      });
      showSnackbar("Зарегистрировано");
      setUsername('');
      setPassword('');
      setConfirmPassword('');
      setEmail('');
    } catch (error) {
      showSnackbar(error.response?.data?.message || 'Регистрация не удалась', 'snackbarWarning');
     }
  };